import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const useGetVendorData = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  const apiKey = process.env.REACT_APP_API;
  useEffect(() => {
    fetchData();

    return () => {};
  }, []);
  const fetchData = async () => {
    try {
      console.log("id", id, "get vendors");
      const response = await axios.post(`${apiKey}/get_vendor_names`, {
        user_identifier: id,
      });
      console.log(response)
      

      setData(response.data.vendor_names);
    } catch (error) {
      console.log(error)
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  return { data, loading, error };
};

export default useGetVendorData;
